module.exports = __webpack_public_path__ + "static/media/subjectTrain.63579270.jpg";